export const getSystemBaseAddress = (province) => {
  let backendAddress;
  if (province === "markazi") {
    backendAddress = "https://mabackend.rasadyar.com/";
  } else if (province === "hamedan") {
    backendAddress = "https://habackend.rasadyar.com/";
  } else if (province === "bushehr") {
    backendAddress = "https://bubackend.rasadyar.com/";
  } else {
    province = "ha";
  }

  return backendAddress;
};
